/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseMandateType } from '../../models/response-mandate-type';

export interface GetAllMandateTypes$Params {
}

export function getAllMandateTypes(http: HttpClient, rootUrl: string, params?: GetAllMandateTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseMandateType>> {
  const rb = new RequestBuilder(rootUrl, getAllMandateTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseMandateType>;
    })
  );
}

getAllMandateTypes.PATH = '/bankdetails/mandate/types';
